import RecruitmentConstants from "../constants/recruitment-constants";


const initState = {
	hiringManagement: {
		filters: {
			page: 1,
			username: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	interviewManagement: {
		filters: {
			page: 1,
			search_start_time: "",
			search_end_time: "",
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	notificationTemplate: {
		filters: {
			page: 1,
			keyword: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	recruitmentRequirement: {
		filters: {
			page: 1,
			position_name: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	recruitmentSetting: {
		filters: {
			page: 1,
			keyword: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	recruitmentStatistics: {
		filters: {
			page: 1,
			create_date: ""
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	resumeLibrary: {
		filters: {
			page: 1,
			username: "",
			position_id: ""
		},
		data: [],
		positions: [],
		dataStatus: "unload",
		loadCounter: 0
	}
};


export default function recruitment (state = initState, action) {
	switch (action.type) {

		// hiring management
		case RecruitmentConstants.ActionTypes.CHANGEHIRINGMANAGEMENT:
			return {
				...state,
				hiringManagement: {
					...state.hiringManagement,
					filters: {
						...state.hiringManagement.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.hiringManagement.loadCounter + action.payload.counter
				}
			}

		case RecruitmentConstants.ActionTypes.SELECTHIRINGMANAGEMENT:
			return {
				...state,
				hiringManagement: {
					...state.hiringManagement,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		// interview management
		case RecruitmentConstants.ActionTypes.CHANGEINTERVIEWMANAGEMENT:
			return {
				...state,
				interviewManagement: {
					...state.interviewManagement,
					filters: {
						...state.interviewManagement.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.interviewManagement.loadCounter + action.payload.counter
				}
			}

		case RecruitmentConstants.ActionTypes.SELECTINTERVIEWMANAGEMENT:
			return {
				...state,
				interviewManagement: {
					...state.interviewManagement,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		// notification template
		case RecruitmentConstants.ActionTypes.CHANGENOTIFICATIONTEMPLATE:
			return {
				...state,
				notificationTemplate: {
					...state.notificationTemplate,
					filters: {
						...state.notificationTemplate.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.notificationTemplate.loadCounter + action.payload.counter
				}
			}

		case RecruitmentConstants.ActionTypes.SELECTNOTIFICATIONTEMPLATE:
			return {
				...state,
				notificationTemplate: {
					...state.notificationTemplate,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		case RecruitmentConstants.ActionTypes.UPDATENOTIFICATIONTEMPLATE:
			return {
				...state,
				notificationTemplate: {
					...state.notificationTemplate,
					data: {
						...state.notificationTemplate.data,
						Data: [
							...state.notificationTemplate.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.notificationTemplate.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}
		// recruitment requirement
		case RecruitmentConstants.ActionTypes.CHANGERECUITMENTREQUIREMENT:
			return {
				...state,
				recruitmentRequirement: {
					...state.recruitmentRequirement,
					filters: {
						...state.recruitmentRequirement.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.recruitmentRequirement.loadCounter + action.payload.counter
				}
			}

		case RecruitmentConstants.ActionTypes.SELECTRECUITMENTREQUIREMENT:
			return {
				...state,
				recruitmentRequirement: {
					...state.recruitmentRequirement,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case RecruitmentConstants.ActionTypes.UPDATERECUITMENTREQUIREMENT:
			return {
				...state,
				recruitmentRequirement: {
					...state.recruitmentRequirement,
					data: {
						...state.recruitmentRequirement.data,
						Data: [
							...state.recruitmentRequirement.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.recruitmentRequirement.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		// recruitment setting
		case RecruitmentConstants.ActionTypes.CHANGERECRUITMENTSETTING:
			return {
				...state,
				recruitmentSetting: {
					...state.recruitmentSetting,
					filters: {
						...state.recruitmentSetting.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.recruitmentSetting.loadCounter + action.payload.counter
				}
			}

		case RecruitmentConstants.ActionTypes.SELECTRECRUITMENTSETTING:
			return {
				...state,
				recruitmentSetting: {
					...state.recruitmentSetting,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}
		case RecruitmentConstants.ActionTypes.UPDATERECRUITMENTSETTING:
			return {
				...state,
				recruitmentSetting: {
					...state.recruitmentSetting,
					data: {
						...state.recruitmentSetting.data,
						Data: [
							...state.recruitmentSetting.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.recruitmentSetting.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		// recruistment statistics
		case RecruitmentConstants.ActionTypes.CHANGERECRUITMENTSTATISTICS:
			return {
				...state,
				recruitmentStatistics: {
					...state.recruitmentStatistics,
					filters: {
						...state.recruitmentStatistics.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.recruitmentStatistics.loadCounter + action.payload.counter
				}
			}

		case RecruitmentConstants.ActionTypes.SELECTRECRUITMENTSTATISTICS:
			return {
				...state,
				recruitmentStatistics: {
					...state.recruitmentStatistics,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		// resume library
		case RecruitmentConstants.ActionTypes.CHANGERESUMELIBRARY:
			return {
				...state,
				resumeLibrary: {
					...state.resumeLibrary,
					filters: {
						...state.resumeLibrary.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.resumeLibrary.loadCounter + action.payload.counter
				}
			}

		case RecruitmentConstants.ActionTypes.SELECTRESUMELIBRARY:
			return {
				...state,
				resumeLibrary: {
					...state.resumeLibrary,
					data: action.payload.data,
					positions: action.payload.positions,
					dataStatus: action.payload.status
				}
			}

		case RecruitmentConstants.ActionTypes.UPDATERESUMELIBRARY:
			return {
				...state,
				resumeLibrary: {
					...state.resumeLibrary,
					data: {
						...state.resumeLibrary.data,
						Data: [
							...state.resumeLibrary.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.resumeLibrary.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		default :
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/recruitment-reducer.js